import { containsAll } from '../utils';

/**
 * An extended version of the `HisOption` defined in the generic search model. Allows additonal data by definition to
 * avoid the usage of any or inline type conversion.
 * 
 * `HisOption` specific fields are defined as _readonly_ to enforce immutability of option instances.
 */
export interface HisOptionXtd {
    /** Additional custom fields to attach to an option. Can be used for advanced filtering or relevant custom data. */
    [field: string]: any;
    /** Immutable id for the option. Should be unique in a collection to identify specific options. */
    readonly id: string;
    /** Immutable label as display text for the option. Also used as default for filter operations. */
    readonly label: string;
}

/**
 * Defines a group of `HisOptionXtd`, referenced as `items`. Declares a `label` as the groupname and an optional
 * `icon` (as a _hisImage_) to display along with the name.
 */
export interface HisOptionGroup {
    /** The grouped `HisOptionXtd`s */
    items: HisOptionXtd[];
    /** The group title */
    label: string;
    /** Optional hisImage as an icon for the group */
    icon?: string;
}

/** Helper to identify if an `obj` matches the type contract for a `HisOptionXtd`. */
export function isHisOption( obj: any ): obj is HisOptionXtd {
    return obj && containsAll( Object.keys( obj ), ['id', 'label'] );
}

/** Helper to identify if an `obj` matches the type contract for a `HisOptionGroup`. */
export function isHisOptionGroup( obj: any ): obj is HisOptionGroup {
    return obj && Object.keys( obj ).includes( 'label' ) && Array.isArray( obj.items );
}
